import { render, staticRenderFns } from "./PatternSwatchList.vue?vue&type=template&id=e72bcc44&scoped=true&"
import script from "./PatternSwatchList.vue?vue&type=script&lang=js&"
export * from "./PatternSwatchList.vue?vue&type=script&lang=js&"
import style0 from "./PatternSwatchList.vue?vue&type=style&index=0&id=e72bcc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72bcc44",
  null
  
)

export default component.exports